import { BsViewStacked, BsGrid } from "react-icons/bs";

export default function ShopFilter() {
  return (
    <>
      <div className="max-w-5xl flex justify-between items-center h-48 mx-auto ">
        <div>
          <h2 className="text-xl font-bold font-fontOne ">
            Ecommerce Accesories & Fashion Items
          </h2>
          <p className=" text-sub_text_color text-sm">
            About 9.620 results (0.62 seconds)
          </p>
        </div>
        <div className="flex text-sub_text_color">
          <div>
            <label for="prepage">Per Page: </label>
            <input
              id="prepage"
              type="number"
              className=" w-16 border border-[#E7E6EF] pl-1 ml-2 focus:outline-pink"
            />
          </div>
          <div className="ml-6">
            <label for="prepage">Sort By: </label>
            <select
              id="prepage"
              type="select"
              className=" w-32 rounded-sm border border-[#E7E6EF] pl-1 ml-2"
            >
              <option>Best Match</option>
            </select>
          </div>
          <div className="flex ml-6">
            <label for="prepage" className="flex items-center">
              View:&nbsp;
              <BsGrid size={15} className="mx-1" />
              <BsViewStacked size={15} />
            </label>
            <input
              id="prepage"
              type="text"
              className=" w-16 border border-[#E7E6EF] pl-1 ml-2 focus:outline-pink"
            />
          </div>
        </div>
      </div>
    </>
  );
}
